import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitMenusMenuItem.module.scss';

const MenuItem = ({
  className = '',
  children,
  variant = '',
  isDisabled = false,
  onBlur = null,
  onClick = null,
  onFocus = null,
  onKeyDown = null,
  onKeyUp = null,
  tabIndex = '-1',
  testId = '',
}) => {
  const CLASSES = {
    variant: {
      bounded: styles.isVariantBounded,
      unbounded: styles.isVariantUnbounded,
    },
  };

  return (
    <li
      className={classnames(
        styles.element,
        { [CLASSES.variant[variant]]: variant, [styles.isDisabled]: isDisabled },
        className,
      )}
      data-testid={testId}
      onBlur={onBlur}
      onClick={onClick}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      role="menuitem"
      tabIndex={tabIndex}
    >
      {children}
    </li>
  );
};

MenuItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['bounded', 'unbounded', '']),
  isDisabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  testId: PropTypes.string,
};

export { MenuItem as MenuItemStorybook };
export default React.memo(MenuItem);
